import Ad from "../pages/AD/Ad";
import Home from "../pages/Home/Home";
import Login from "../pages/Login/Login";
import UserAdd from "../pages/User_Management/UserAdd/UserAdd";
import Users from "../pages/User_Management/Users/Users";
import CropYearRegistration from "components/pages/CropYearRegistration/CropYearRegistration";
import Profiles from "../pages/Profiles/Profiles";
import SaveCropYearRegistration from "components/pages/CropYearRegistration/SaveCropYearRegistration";
import AddProfiles from "components/pages/Profiles/AddProfiles";
import SeasonRegistration from "components/pages/SeasonRegistration/SeasonRegistration";
import CropStage from "components/pages/CropStage/CropStage";
import AddCropStage from "components/pages/CropStage/AddCropStage";
import Dashboard from "../pages/Dashboard/Dashboard";
import AddSeason from "components/pages/SeasonRegistration/AddSeason";
import AddModuleRegistration from 'components/pages/ModulesRegistration/AddRegistration';
import EditModuleRegistration from 'components/pages/ModulesRegistration/EditRegistration';
import GetModuleRegistration from 'components/pages/ModulesRegistration/GetRegistration';
import GetCropStageRegistartion from 'components/pages/CropStageCalander/GetCropStage';
import AddCropStageCalander from 'components/pages/CropStageCalander/AddCropStage';
import EditCropStageCalander from 'components/pages/CropStageCalander/EditCropStage';
import HierarchyContainer from "components/pages/Hierarchy/HierarchyContainer";
import QuestionnareContainer from "components/pages/QuestionnareSetup/QuestionnareContainer";
import QuestionnareAdd from "components/pages/QuestionnareSetup/QuestionnareAdd";
import QuestionnareEdit from "components/pages/QuestionnareSetup/QuestionnareEdit";
import ImportFarmer from "components/pages/Import/ImportFarmer/ImportFarmer";
import ImportHierarchy from "components/pages/Import/ImportHierarchy/ImportHierarchy";
import ViewLog from "components/pages/Import/ImportFarmer/ViewLog";
import ViewDetails from "components/pages/Import/ImportFarmer/ViewDetails";
import ViewLogHierarchy from "components/pages/Import/ImportHierarchy/ViewLogHierarchy";
import ViewDetailsHierarchy from "components/pages/Import/ImportHierarchy/ViewDetailsHierarchy";
import ReLogin from "components/navbar/ReLogin";
import ImportContract from "components/pages/Import/ImportContract/ImportContract";
import ViewContractDetails from "components/pages/Import/ImportContract/ViewContractDetails";
import ViewContractLog from "components/pages/Import/ImportContract/ViewContractLog";
import RoleCreation from "components/pages/AccessManagement/RoleCreation/RoleCreation";
import AddRole from "components/pages/AccessManagement/RoleCreation/AddRole";
import EditRole from "components/pages/AccessManagement/RoleCreation/EditRole";
import UserCreation from "components/pages/AccessManagement/UserCreation/UserCreation";
import AddUser from "components/pages/AccessManagement/UserCreation/AddUser";
import Export from "components/pages/AccessManagement/Common/Export";
import RoleAssignHome from "components/pages/AccessManagement/RoleAssign/RoleAssignHome";
import RoleEdit from "components/pages/AccessManagement/RoleAssign/RoleEdit";
import RoleAssign from "components/pages/AccessManagement/RoleAssign/RoleAssign";
import RoleAssignModuleEdit from "components/pages/AccessManagement/RoleAssign/RoleAssignModuleEdit";
import RoleAssignSubmoduleEdit from "components/pages/AccessManagement/RoleAssign/RoleAssignSubmoduleEdit";

import UserDelegation from "components/pages/AccessManagement/UserCreation/UserDelegation";
import RoleDelegation from "components/pages/AccessManagement/RoleCreation/RoleDelegation";
import RoleScreen from "components/pages/AccessManagement/RoleScreen/RoleScreen";
import Report from "components/pages/Report/Report";
import RuleCreation from "components/pages/AccessManagement/ConflictIndicator/RuleCreation/RuleCreation";
import CreateNewRule from "components/pages/AccessManagement/ConflictIndicator/RuleCreation/CreateNewRule";
import RoleAssignList from "components/pages/AccessManagement/RoleAssign/RoleAssignList";
import DelegationUpdate from "components/pages/AccessManagement/Common/DelegationUpdate";
import AdministratorCreation from "components/pages/AccessManagement/AdministratorCreation/AdministratorCreation";
import AddAdministtrator from "components/pages/AccessManagement/AdministratorCreation/AddAdministrator";
import EditAdministrator from "components/pages/AccessManagement/AdministratorCreation/EditAdministrator";
import AdministratorDelegation from "components/pages/AccessManagement/AdministratorCreation/AdministratorDelegation";
import DelegationUi from "components/pages/AccessManagement/Delegation/DelegationUi";
import SelfDelegation from "components/pages/AccessManagement/Delegation/SelfDelegation";
import OtherDelegation from "components/pages/AccessManagement/Delegation/OtherDelegation";
import DelegationNew from "components/pages/AccessManagement/Delegation/DelegationNew";
import EditOtherDelegation from "components/pages/AccessManagement/Delegation/EditOtherDelegation";
// import MenuScreen from components/pages/AccessManagement/UserCreation/UserCreation
import AdministratorUserList from "components/pages/AccessManagement/AdministratorCreation/AdministratorUserCreation/UserCreation";
import AdministratorUserAdd from "components/pages/AccessManagement/AdministratorCreation/AdministratorUserCreation/AddUser";
import SelfDelegationList from "components/pages/AccessManagement/Delegation/SelfDelegationList";
import MUV from "components/pages/ManageUnannouncedVisitor/MUV";
import MUVSubGrower from "components/pages/ManageUnannouncedVisitorSubGrower/MUVSubGrower";
import AnalyticalReports from "components/pages/AnalyticalReports/AnalyticalReports";
import SurveyReopen from "components/pages/SurveyManagement/SurveyReopen";
import SurveyReopenSubGrower from "components/pages/SurveyManagement/SurveyReopenSubGrower";
//import CropDevelopment from "components/pages/SurveyManagement/CropDevelopment";
import SignaturePage from "components/pages/SurveyManagement/SignaturePage";
import ViewSurvey from "components/pages/SurveyManagement/ViewSurvey";
import TranslationNotification from "components/pages/TranslationNotification/TranslationNotification";
import UserLoginReport from "components/pages/UserLoginReport/UserLoginReport";
import CropSeasonList from "components/pages/CropSeasonList/CropSeasonList";
import CheckPendingTranslation from "components/pages/CheckPendingTranslation/CheckPendingTranslation";
import PromptActionNotification from "components/pages/PromptActionNotification/PromptActionNotification";
import GetReports from "components/pages/AccessManagement/Reports/GetReports";
import ImportWood from "components/pages/Import/ImportWoodSupplier/ImportWood";
import ViewWoodLog from "components/pages/Import/ImportWoodSupplier/ViewWoodLog";
import ViewWoodDetails from "components/pages/Import/ImportWoodSupplier/ViewWoodDetails";
import CountrySelection from "components/pages/AccessManagement/CountrySelection/CountrySelection";
import PendingVerification from "components/pages/AccessManagement/RoleCreation/PendingVerification";
import SRNumberInput from "components/pages/AccessManagement/RoleCreation/SRNumberInput";
import WoodSupplierTask from "components/pages/WoodSupplierTask/WoodSupplierTask";
import LockedUser from "./LockedUser";
import ReadOnlyUserMapping from "components/pages/AccessManagement/RoleScreen/ReadOnlyUserMapping";
import Agri360UserReport from "components/pages/Report/Agri360UserReport";
import ImportFT from "components/pages/Import/ImportFT/ImportFT";
import ViewFTLog from "components/pages/Import/ImportFT/ViewLog";
import ImportSubGrower from "components/pages/Import/ImportSubGrower/ImportSubGrower";
import ViewLogSubGrower from "components/pages/Import/ImportSubGrower/ViewLogSubGrower";
import ViewDetailsSubGrower from "components/pages/Import/ImportSubGrower/ViewDetailsSubGrower";

export const nav = [
  {
    path: "/dashboard",
    name: "Agri360 ESG Portal Dashboard",
    element: <Dashboard />,
    isPrivate: true,
  },
  {
    path: "/",
    name: "Access Management Menu",
    element: <RoleAssignHome />,
    isPrivate: true,
  },
 {
    path: "/locked",
    name: "Locked User",
    element: <LockedUser />,
    isPrivate: true,
  },
  {
    path: "/v2",
    name: "Access Management",
    element: <RoleAssignHome />,
    isPrivate: true,
  },
  {
    path: "/v1",
    name: "Access Management",
    element: <RoleAssignHome />,
    isPrivate: true,
  },
  {
    path: "/roleEdit",
    name: "Assign Functionality",
    element: <RoleEdit />,
    isPrivate: true,
  },
  {
    path: "/roleAssign",
    name: "Assign Functionality",
    element: <RoleAssign />,
    isPrivate: true,
  },
  {
    path: "/roleAssignList",
    name: "Assign Functionality",
    element: <RoleAssignList />,
    isPrivate: true,
  },
  {
    path: "/roleAssign/editmodule/:id",
    name: "Assign Functionality",
    element: <RoleAssignModuleEdit />,
    isPrivate: true,
  },
  {
    path: "/roleAssign/editSubmodule/:id",
    name: "Assign Functionality",
    element: <RoleAssignSubmoduleEdit />,
    isPrivate: true,
  },
  
  {
    path: "/home",
    name: "Home",
    element: <Home />,
    isPrivate: true,
  },
  // {
  //   path: "/login",
  //   name: "Login",
  //   element: <Login />,
  //   isPrivate: false,
  // },
  {
    path: "/users",
    name: "Manage Users",
    element: <Users />,
    isPrivate: false,
  },
  {
    path: "/users/add",
    name: "Manage Users",
    element: <UserAdd />,
    isPrivate: false,
  },
  {
    path: "/users/:id",
    name: "Manage Users",
    element: <UserAdd />,
    isPrivate: false,
  },
  {
    path: "/ad",
    name: "AD",
    element: <Ad />
  },
  {
    path: "/cropYearRegistration",
    name: "Crop Year Registration",
    element: <CropYearRegistration />,
    isPrivate: false,
  },
  {
    path: "/saveCropYearRegistration",
    name: "Crop Year Registration",
    element: <SaveCropYearRegistration />,
    isPrivate: false,
  },
  {
    path: "/manageProfiles",
    name: "Manage Profiles",
    element: <Profiles />,
    isPrivate: false,
  },
  {
    path: "/addProfiles",
    name: "Manage Profiles",
    element: <AddProfiles />,
    isPrivate: false,
  },
  {
    path: "/editProfiles",
    name: "Manage Profiles",
    element: <AddProfiles />,
    isPrivate: false,
  },
  {
    path: "/seasonRegistration",
    name: "Season Registration",
    element: <SeasonRegistration />,
    isPrivate: false,
  },

  {
    path: "/addSeason",
    name: "Season Registration",
    element: <AddSeason />,
    isPrivate: false,
  },
  {
    path: "/editSeason",
    name: "Season Registration",
    element: <AddSeason />,
    isPrivate: false,
  },
  {
    path: "/cropStage",
    name: "Crop Stage Registration",
    element: <CropStage />,
    isPrivate: false,
  },

  {
    path: "/addCropStage",
    name: "Crop Stage Registration",
    element: <AddCropStage />,
    isPrivate: false,
  },
  {
    path: "/editCropStage/:id",
    name: "Crop Stage Registration",
    element: <AddCropStage />,
    isPrivate: false,
  },
  {
    path: "/getmoduleregistration",
    name: "Module Registration",
    element: <GetModuleRegistration />,
    isPrivate: false,
  },

  {
    path: "/editmoduleregistration",
    name: "Module Registration",
    element: <EditModuleRegistration />,
    isPrivate: false,
  },

  {
    path: "/addmoduleregistration",
    name: "Module Registration",
    element: <AddModuleRegistration />,
    isPrivate: false,
  },
  {
    path: "/getCropStageCalendar",
    name: "Crop Stage Calendar",
    element: <GetCropStageRegistartion />,
    isPrivate: false,
  },
  {
    path: "/addCropStageCalendar",
    name: "Crop Stage Calendar",
    element: <AddCropStageCalander />,
    isPrivate: false,
  },
  {
    path: "/editCropStageCalendar",
    name: "Crop Stage Calendar",
    element: <EditCropStageCalander />,
    isPrivate: false,
  },
  {
    path: "/hierarchyConfiguration",
    name: "Hierarchy Configuration",
    element: <HierarchyContainer />,
    isPrivate: false,
  },
  {
    path: "/QuestionnaireSetup",
    name: "Questionnaire Setup",
    element: <QuestionnareContainer />,
    isPrivate: false,
  },
  {
    path: "/Questionnaire",
    name: "Questionnaire Setup",
    element: <QuestionnareAdd />,
    isPrivate: false,
  },
  {
    path: "/QuestionnaireEdit",
    name: "Questionnaire Setup",
    element: <QuestionnareEdit />,
    isPrivate: false,
  },
  {
    path: "/QuestionnaireView/:id",
    name: "Questionnaire Setup",
    element: <QuestionnareEdit />,
    isPrivate: false,
  },
  {
    path: "/QuestionnaireView",
    name: "Questionnaire Setup",
    element: <QuestionnareEdit />,
    isPrivate: false,
  },
  {
    path: "/ImportFarmer",
    name: "Import Farmer",
    element: <ImportFarmer />,
    isPrivate: false,
  },
  {
    path: "/viewFarmerLog/:id",
    name: "Import Farmer",
    element: <ViewLog />,
    isPrivate: false,
  },
  {
    path: "/viewFarmerDetails/:id",
    name: "Import Farmer",
    element: < ViewDetails />,
    isPrivate: false,
  },
  {
    path: "/ImportHierarchy",
    name: "Import Hierarchy",
    element: <ImportHierarchy />,
    isPrivate: false,
  },
  {
    path: "/viewHierarchyLog/:id",
    name: "Import Hierarchy",
    element: <ViewLogHierarchy />,
    isPrivate: false,
  },
  {
    path: "/viewHierarchyDetails/:id",
    name: "Import Hierarchy",
    element: <ViewDetailsHierarchy />,
    isPrivate: false,
  },
  {
    path: "/inactivity",
    name: "Session Timeout Alert",
    element: <ReLogin />,
    isPrivate: false,
  },
  {
    path: "/ImportContract",
    name: "Import Contract",
    element: <ImportContract />,
    isPrivate: false,
  },
  {
    path: "/viewContractLog/:id",
    name: "Import Contract",
    element: <ViewContractLog />,
    isPrivate: false,
  },
  {
    path: "/viewContractDetails/:id",
    name: "Import Contract",
    element: <ViewContractDetails />,
    isPrivate: false,
  },
  {
    path: "/ImportWood",
    name: "Import Wood Supplier",
    element: <ImportWood />,
    isPrivate: false,
  },
  {
    path: "/viewWoodLog/:id",
    name: "Import Wood Supplier",
    element: <ViewWoodLog />,
    isPrivate: false,
  },
  {
    path: "/viewWoodDetails/:id",
    name: "Import Wood Supplier",
    element: <ViewWoodDetails />,
    isPrivate: false,
  },
  {
    path: "/roleCreation",
    name: "Manage Profiles",
    element: <RoleCreation />,
    isPrivate: false,
  },
  {
    path: "/addRoleCreation",
    name: "Manage Profiles",
    element: <AddRole />,
    isPrivate: false,
  },
  {
    path: "/editRoleCreation",
    name: "Manage Profiles",
    element: <EditRole />,
    isPrivate: false,
  },
  {
    path: "/userCreation",
    name: "Manage Users",
    element: <UserCreation />,
    isPrivate: false,
  },
  {
    path: "/addUser",
    name: "Manage Users",
    element: <AddUser />,
    isPrivate: false,
  },
  {
    path: "/editUserCreation",
    name: "Manage Users",
    element: <AddUser />,
    isPrivate: false,
  },
  {
    path: "/export",
    name: "Export",
    element: <Export />,
    isPrivate: false,
  },
  {
    path: "/userDelegation",
    name: "Delegation",
    element: <UserDelegation />,
    isPrivate: false,
  },
  {
    path: "/roleDelegation",
    name: "Delegation",
    element: <RoleDelegation />,
    isPrivate: false,
  },
  {
    path: "/delegationUpdate",
    name: "Delegation",
    element: <DelegationUpdate />,
    isPrivate: false,
  },
  {
    path: "/roleNavigation",
    name: "Access Management Navigation",
    element: <RoleScreen />,
    isPrivate: false,
  },
  {
    path: "/reports",
    name: "Reports",
    element: <Report />,
    isPrivate: false,
  },
  {
    path: "/conflictIndicator",
    name: "Conflict Indicator",
    element: < RuleCreation/>,
    isPrivate: false,
  },
  {
    path: "/createNewRule",
    name: "Conflict Indicator",
    element: <CreateNewRule/>,
    isPrivate: false,
  },
  {
    path: "/administratorCreation",
    name: "Manage Profiles",
    element: <AdministratorCreation/>,
    isPrivate: false,
  },
  {
    path: "/addAdministratorCreation",
    name: "Manage Profiles",
    element: <AddAdministtrator/>,
    isPrivate: false,
  },
  {
    path: "/editadministratorCreation",
    name: "Manage Profiles",
    element: <EditAdministrator />,
    isPrivate: false,
  },
  {
    path: "/administratorDelegation",
    name: "Delegation",
    element: <AdministratorDelegation />,
    isPrivate: false,
  },
  {
    path: "/administratorUserList",
    name: "Manage Users",
    element: <AdministratorUserList />,
    isPrivate: false,
  },
  {
    path: "/administratorUserAdd",
    name:  "Manage Users",
    element: <AdministratorUserAdd />,
    isPrivate: false,
  },
  {
    path: "/editAdministratorUserAdd",
    name: "Manage Users",
    element: <AdministratorUserAdd />,
    isPrivate: false,
  },
   { path: "/ownAndOthersDelegation",
    name: "Other Delegation",
    element: < DelegationUi/>,
    isPrivate: false,
  },
  {
    path: "/selfDelegation",
    name: "Delegation",
    element: < SelfDelegation/>,
    isPrivate: false,
  },
  {
    path: "/otherDelegation",
    name: "Other Delegation",
    element: < OtherDelegation/>,
    isPrivate: false,
  },
  {
    path: "/delegationNew",
    name: "Other Delegation",
    element: < DelegationNew/>,
    isPrivate: false,
  },
  {
    path: "/editDelegation",
    name: "Other Delegation",
    element: < EditOtherDelegation/>,
    isPrivate: false,
  },
  {
    path: "/selfDelegationList",
    name: "Delegation",
    element: < SelfDelegationList/>,
    isPrivate: false,
  },

  {
    path: "/manageUnannouncedVisit",
    name: "Manage Unannounced Visit",
    element: <MUV/>,
    isPrivate: false,
  },
  {
    path: "/manageUnannouncedVisitorSubGrower",
    name: "Manage Unannounced Visit - Sub Grower",
    element: <MUVSubGrower/>,
    isPrivate: false,
  },
  {
    path: "/analyticalreports",
    name: "Analytical Question Report",
    element: <AnalyticalReports />,
    isPrivate: false,
  },
  {
    // path: "/viewsurvey/:headerId",
    path: "/viewsurvey",
    name: "Survey Reopen/Approve",
    element: <ViewSurvey />,
    isPrivate: false,
  },
  {
    path: "/signaturePage",
    name: "Survey Reopen/Approve",
    element: <SignaturePage/>,
    isPrivate: false,
  },
  {
    path: "/surveyManagement",
    name: "Survey Reopen/Approve",
    element: <SurveyReopen />,
    isPrivate: false,
  },
  {
    path: "/surveyManagementSubGrower",
    name: "Survey Reopen/Approve - Sub Grower",
    element: <SurveyReopenSubGrower />,
    isPrivate: false,
  },
  {
    path: "/sendTranslationNotification",
    name: "Send Notification for Translation",
    element: <TranslationNotification />},
    {
    path: "/userLoginReport",
    name: "User Login Report",
    element: <UserLoginReport />,
    isPrivate: false,
  },
  {
    path: "/cropSeasonList",
    name: "Season Registration",
    element: <CropSeasonList />,
    isPrivate: false,
  },
  {
    path: "/checkPendingTranslation",
    name: "Translation report",
    element: <CheckPendingTranslation />,
    isPrivate: false,
  },
  {
    path: "/promptActionNotification",
    name: "Prompt Action Notification",
    element: <PromptActionNotification />,
    isPrivate: false,
  },
  {
    path: "/getReports",
    name: "SOX Reports",
    element: <GetReports />,
    isPrivate: false,

  },
  {
    path: "/countrySelection",
    name: "Manage Profiles",
    element: <CountrySelection />,
    isPrivate: false,
  },
 
   {
    path: "/pending-verification",
    name: "Manage Profiles",
    element: <PendingVerification />,
    isPrivate: false,
  },
  {
    path: "/sr-number-input",
    name: "Manage Profiles",
    element: <SRNumberInput />,
    isPrivate: false,
  },
  {
    path: "/woodSupplierTask",
    name: "Wood Supplier Task",
    element: <WoodSupplierTask />,
    isPrivate: false,
  },
  {
    path: "/woodSupplierTask",
    name: "Wood Supplier List",
    element: <WoodSupplierTask />,
    isPrivate: false,
  },
  {
    path: "/readOnlyUserMapping",
    name: "Read Only User Mapping",
    element: <ReadOnlyUserMapping />,
    isPrivate: false,
  },
  {
    path: "/agri360UserReport",
    name: "Agri360 User Report",
    element: <Agri360UserReport />,
    isPrivate: false,
  },
  {
    path: "/ImportFT",
    name: "Import FT to FA Mapping",
    element: <ImportFT />,
    isPrivate: false,
  },
  {
    path: "/viewFTLog/:id",
    name: "Import FT to FA Mapping",
    element: <ViewFTLog />,
    isPrivate: false,
  },
  {
    path: "/ImportSubGrower",
    name: "Import Sub Grower",
    element: <ImportSubGrower />,
    isPrivate: false,
  },
  {
    path: "/viewSubGrowerLog/:id",
    name: "Import Sub Grower",
    element: <ViewLogSubGrower />,
    isPrivate: false,
  },
  {
    path: "/viewSubGrowerDetails/:id",
    name: "Import Sub Grower",
    element: <ViewDetailsSubGrower />,
    isPrivate: false,
  },
];
